import { css } from '@emotion/react';

export default css`
  opacity: 0;
`;